import React, { useState, useEffect } from 'react';
import SvgIcon from "../../utils/Icon";
import { ReactComponent as Aliado } from "../../assets/icons/aliado.svg";
import apiClient from '../../utils/axiosPetition';
import { alertaGeneral } from '../../utils/alertas';
import AliadoFicha from '../DoctorComponent/AliadoFicha';
import { dedupeAliados } from '../DoctorComponent/aliadosContenido';

const PatientAliados = () => {
  const [aliados, setAliados] = useState([]);
  const [loading, setLoading] = useState(true);
  const getAliadosParaPacientes = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return { success: false, message: 'Token requerido' };
      const baseURL = process.env.REACT_APP_BACKEND_URL || '';
      const response = await fetch(`${baseURL}/api/aliados/patients`, {
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
      });
      const data = await response.json();
      return data.success ? data : { ...data, success: false };
    } catch (error) {
      console.error('Error de red:', error);
      return { success: false, error: error.message };
    }
  };

  const fetchAliados = async () => {
    setLoading(true);
    try {
      const patientData = await getAliadosParaPacientes();
      if (patientData.success) {
        setAliados(dedupeAliados(patientData.data || []));
      } else {
        const res = await apiClient.get('/api/aliados');
        const aliadosActivos = Array.isArray(res.data.data)
          ? res.data.data.filter(a => a.estado === 'activo' && a.visible !== false)
          : [];
        setAliados(dedupeAliados(aliadosActivos));
      }
    } catch (err) {
      console.error('Error al cargar aliados:', err);
      alertaGeneral({ titulo: 'Error', messageHtml: 'Error al cargar los aliados.', isError: true });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAliados();
  }, []);

  if (loading) {
    return (
      <div className="space-y-6 sm:space-y-8 pb-6 sm:pb-8">
        <div className="mx-2 sm:mx-4">
          <div className="mb-4 sm:mb-6">
            <h2 className="text-lg sm:text-2xl font-bold text-gray-800 flex items-center gap-2 sm:gap-4">
              <div className="bg-gradient-to-r from-[#f79865ff] to-[#ffaa6b] p-2.5 sm:p-3 rounded-xl shadow-md">
                <SvgIcon Icon={Aliado} className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
              </div>
              Aliados estratégicos
            </h2>
          </div>
          <div className="bg-white rounded-xl sm:rounded-2xl shadow-md p-6 sm:p-8 border border-gray-200">
            <div className="text-center text-gray-600 py-8 sm:py-10">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#f79865ff] mb-4"></div>
              <p className="text-sm sm:text-base">Cargando aliados...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 sm:space-y-8 pb-6 sm:pb-8">
      {/* Sección Aliados */}
      <div className="mx-2 sm:mx-4">
        <div className="mb-4 sm:mb-6">
          <h2 className="text-lg sm:text-2xl font-bold text-gray-800 flex items-center flex-wrap gap-2">
            <div className="bg-gradient-to-r from-[#f79865ff] to-[#ffaa6b] p-2.5 sm:p-3 rounded-xl shadow-md">
              <SvgIcon Icon={Aliado} className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
            </div>
            Aliados estratégicos
          </h2>
        </div>
        <div className="bg-white rounded-xl sm:rounded-2xl shadow-md p-4 sm:p-6 md:p-8 border border-gray-200">
          {aliados.length === 0 ? (
            <div className="text-center text-gray-500 py-8 sm:py-10">
              <SvgIcon Icon={Aliado} className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-3 sm:mb-4 text-gray-300" />
              <p className="text-base sm:text-lg">No hay aliados disponibles en este momento.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
              {aliados.map((aliado, index) => (
                <AliadoFicha key={aliado._id || aliado.id || index} aliado={aliado} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PatientAliados;
